var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.cbedb21a61290279ee6b98fb68f52998.svg#b';
                    var viewUrl = 'sprites.cbedb21a61290279ee6b98fb68f52998.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };